'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { inputBoxStyled, inputTextStyled } from '@/app/components/forms/styles';
import { Icon } from '@/app/components/icons';
import { IconArrowDropDown } from '@/app/components/icons/ui-actions/icon-arrow-drop-down';
import { SpartanProductCustomizeGradeLabel } from '@/app/lcv/components/sections/spartan/products/customize/configurator/grade-label';
import { scrollSpartanCustomizePreviewIntoView } from '@/app/lcv/components/sections/spartan/products/customize/configurator/grade-selection/scroll-to-preview';
import type { SpartanProductCustomizeGradeSelectionProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/grade-selection/types';
import { SPARTAN_PRODUCT_CUSTOMIZE_GRADE_DRAWER_INSTANCE_ID } from '@/app/lcv/components/sections/spartan/products/customize/constants';
import { SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA, SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import type { SpartanCustomizeModel } from '@/app/lcv/components/sections/spartan/products/customize/types';
import { SPARTAN_PRODUCTS_EVENT_NAME } from '@/app/lcv/components/sections/spartan/products/shared/tracking';
import { SPARTAN_PRODUCT_CUSTOMIZE_LABELS } from '@/app/lcv/contents/spartan/products/shared/customize-common-fields.data';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
const SpartanProductCustomizeGradeDrawer = dynamic(() => import('@/app/lcv/components/sections/spartan/products/customize/configurator/grade-selection/drawer').then(mod => mod.SpartanProductCustomizeGradeDrawer), {
  ssr: false
});
export const SpartanProductCustomizeGradeSelection = t0 => {
  const $ = _c(44);
  const {
    theme: t1,
    models,
    selectedModel,
    onSelectModel,
    showSubCategoryTabs: t2,
    subCategories: t3,
    selectedSubCategoryDocumentId,
    onSubCategoryChange
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const showSubCategoryTabs = t2 === undefined ? false : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const subCategories = t4;
  const [isOpen, setIsOpen] = useState(false);
  const selectedLabel = selectedModel.name || selectedModel.title;
  let t5;
  if ($[2] !== isOpen) {
    t5 = () => {
      if (isOpen) {
        return;
      }
      scrollSpartanCustomizePreviewIntoView({
        onSettled: () => setIsOpen(true)
      });
    };
    $[2] = isOpen;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleOpen = t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsOpen(false);
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleClose = t6;
  let t7;
  if ($[5] !== onSelectModel) {
    t7 = model => {
      onSelectModel(model);
      handleClose();
    };
    $[5] = onSelectModel;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleSelectModel = t7;
  let t8;
  if ($[7] !== theme) {
    t8 = cn(inputBoxStyled({
      theme
    }), "group flex h-12 w-full rounded-sm outline-none");
    $[7] = theme;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.gradeSelect
    });
    t10 = createDataGA({
      eventName: SPARTAN_PRODUCTS_EVENT_NAME,
      group: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.section,
      click: true,
      text: SPARTAN_PRODUCT_CUSTOMIZE_LABELS.selectGrade,
      value: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.grade
    });
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconArrowDropDown />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = theme === "dark" ? "text-white" : "text-gray-800";
  let t13;
  if ($[12] !== isOpen || $[13] !== t12) {
    t13 = cn("center-y pointer-events-none absolute right-4 rotate-0 transition-[color,rotate] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none", t12, {
      "rotate-180": isOpen
    });
    $[12] = isOpen;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13) {
    t14 = <Icon icon={t11} aria-hidden="true" className={t13} />;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== theme) {
    t15 = cn(inputTextStyled({
      theme
    }), "flex h-full cursor-pointer items-center pr-12 pl-4 text-ellipsis");
    $[17] = theme;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.gradeSelectLabel
    });
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== selectedLabel) {
    t17 = <span {...t16}><SpartanProductCustomizeGradeLabel>{selectedLabel}</SpartanProductCustomizeGradeLabel></span>;
    $[20] = selectedLabel;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t15 || $[23] !== t17) {
    t18 = <div className={t15}>{t17}</div>;
    $[22] = t15;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== handleOpen || $[26] !== isOpen || $[27] !== t14 || $[28] !== t18 || $[29] !== t8) {
    t19 = <button type="button" className={t8} onClick={handleOpen} aria-expanded={isOpen} aria-haspopup="dialog" aria-controls={SPARTAN_PRODUCT_CUSTOMIZE_GRADE_DRAWER_INSTANCE_ID} aria-label={SPARTAN_PRODUCT_CUSTOMIZE_LABELS.selectGrade} {...t9} {...t10}>{t14}{t18}</button>;
    $[25] = handleOpen;
    $[26] = isOpen;
    $[27] = t14;
    $[28] = t18;
    $[29] = t8;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== handleSelectModel || $[32] !== isOpen || $[33] !== models || $[34] !== onSubCategoryChange || $[35] !== selectedModel.documentId || $[36] !== selectedSubCategoryDocumentId || $[37] !== showSubCategoryTabs || $[38] !== subCategories || $[39] !== theme) {
    t20 = <SpartanProductCustomizeGradeDrawer theme={theme} isOpen={isOpen} onClose={handleClose} models={models} selectedModelDocumentId={selectedModel.documentId} onSelectModel={handleSelectModel} showSubCategoryTabs={showSubCategoryTabs} subCategories={subCategories} selectedSubCategoryDocumentId={selectedSubCategoryDocumentId} onSubCategoryChange={onSubCategoryChange} />;
    $[31] = handleSelectModel;
    $[32] = isOpen;
    $[33] = models;
    $[34] = onSubCategoryChange;
    $[35] = selectedModel.documentId;
    $[36] = selectedSubCategoryDocumentId;
    $[37] = showSubCategoryTabs;
    $[38] = subCategories;
    $[39] = theme;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t19 || $[42] !== t20) {
    t21 = <>{t19}{t20}</>;
    $[41] = t19;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};